import { render, staticRenderFns } from "./person-quick-info.vue?vue&type=template&id=536fa66a&scoped=true"
import script from "./person-quick-info.vue?vue&type=script&lang=js"
export * from "./person-quick-info.vue?vue&type=script&lang=js"
import style0 from "./person-quick-info.vue?vue&type=style&index=0&id=536fa66a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536fa66a",
  null
  
)

export default component.exports